<template>
<div>
  <div v-if="hasAuth">
    <el-row :gutter="4" style="margin-bottom:4px;">
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
      </el-col>
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b25">
      <el-col :span="12">
        <w-collection-judgement-rule-popup-button :obj-info="objInfo"></w-collection-judgement-rule-popup-button>
      </el-col>
      <el-col :span="12">
        <w-common-script-popup-button :obj-info="objInfo"></w-common-script-popup-button>
      </el-col>
    </el-row>
    <div class="title-h4 title-bar">WatchAll 관리 도구 </div>
    <el-row :gutter="4" style="margin-bottom:4px;">
      <el-col :span="12">
        <w-device-modeling-button style="width:100%;" :obj="this.objInfo ? this.objInfo.obj : null" />
      </el-col>
      <el-col :span="12">
        <w-daily-check-button style="width:100%;" :obj="this.objInfo ? this.objInfo.obj : null" />
      </el-col>
    </el-row>
    <el-row :gutter="4" style="margin-bottom:4px;">
      <el-col :span="12">
        <el-button style="width:100%;" size="small" type="primary" @click="onClickExecutePolicyButton">정책위반 감사 수행</el-button>
      </el-col>
      <el-col :span="12">
        <el-button style="width:100%;" size="small" type="primary" @click="$refs.passwdModifyPopup.open()">패스워드변경</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b25">
      <el-col :span="12">
        <w-config-backup-button style="width:100%;" :obj="this.objInfo ? this.objInfo.obj : null" />
      </el-col>
      <el-col :span="12">
        <w-netdevice-user-define-oid-rsc-popup-button :obj-info="objInfo"/>
      </el-col>
    </el-row>
    <w-basic-sliding-button-group :obj-info="objInfo" />
    <w-pass-word-modify-popup ref="passwdModifyPopup" :objId="objInfo.obj.objId" />
  </div>
  <div v-else>
    <el-row :gutter="4" style="margin-bottom:4px;">
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
      </el-col>
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import netdeviceConfigInfoAPI from '@/api/config/netdevice/netdevice-info';
import MsgUtil from '@/utils/message';
import { getBasicNotificationData } from '@/utils/hambuger-popup';
import WPassWordModifyPopup from '@/views/config/group/netdevice/components/popup/PassWordModifyPopup';
import WBasicSlidingButtonGroup from './BasicSlidingButtonGroup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WCommonScriptPopupButton from './CommonScriptPopupButton';
import WCollectionJudgementRulePopupButton from './CollectionJudgementRulePopupButton';
import WEventAlarmRulePopupButton from './EventAlarmRulePopupButton';
import WNetdeviceUserDefineOidRscPopupButton from './NetdeviceUserDefineOidRscPopupButton';
import WDeviceModelingButton from './button/netdevice/DeviceModelingButton';
import WConfigBackupButton from './button/netdevice/ConfigBackupButton';
import WDailyCheckButton from './button/netdevice/DailyCheckButton';

export default {
  name: 'WNetdeviceSlidingButtonGroup',
  components: {
    WBasicSlidingButtonGroup,
    WPassWordModifyPopup,
    WCommonSettingChartTypePopupButton,
    WCommonScriptPopupButton,
    WCollectionJudgementRulePopupButton,
    WEventAlarmRulePopupButton,
    WNetdeviceUserDefineOidRscPopupButton,
    WDeviceModelingButton,
    WConfigBackupButton,
    WDailyCheckButton,
  },
  mixins: [HambugerPopupMixin],
  data() {
    return {
      devicePolicyDatas: [],
    };
  },
  methods: {
    /**
     * [onClickExecutePolicyButton 정책위반 감사 수행]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExecutePolicyButton() {
      const target = '정책위반 감사';
      const action = '수행';
      this.$confirm(...MsgUtil.getCustomConfirmData(`${target}을 ${action}하시겠습니까?`)).then(() => {
        netdeviceConfigInfoAPI
          .getNetdeviceDeviceViolationList({
            objId: this.objInfo.obj.objId,
          })
          .then((result) => {
            if (result.data.success === true) {
              if (isEmpty(result.data.data)) {
                this.$message(MsgUtil.getCustomMsgData('설정된 보안 정책이 없습니다.'));
              } else {
                const policies = result.data.data;
                const params = [];
                policies.forEach((policy) => {
                  const executeParam = {
                    policyId: policy.policyId,
                  };
                  if (policy.objId) executeParam.objId = policy.objId;
                  params.push(executeParam);
                });

                // let count = 0;
                netdeviceConfigInfoAPI.getNetdeviceExecutePolicy(params).then((response) => {
                  if (response.data.success === true) {
                    this.$notify(getBasicNotificationData(this.objInfo.obj, target, true));
                    // TODO: 추후 모든 장비 기능 수행률 표시 가능할 때 일괄 작업. taskManager 사용하도록 수정
                    // const resultHistSeqList = response.data.data;
                    // const getProgressRateInterval = setInterval(() => {
                    //   netdeviceConfigInfoAPI
                    //     .getExecuteProgressRate({
                    //       histSeqList: resultHistSeqList,
                    //     })
                    //     .then((progressResult) => {
                    //       count += 1;
                    //       const progressRate = progressResult.data.data;
                    //       if (progressRate === 1) {
                    //         this.notification('정책위배 감사 수행');
                    //         clearInterval(getProgressRateInterval);
                    //       }
                    //
                    //       if (count > 180) {
                    //         clearInterval(getProgressRateInterval);
                    //         this.$message({
                    //           type: 'error',
                    //           message: '시간 초과로 진행률 확인을 실패하였습니다.',
                    //         });
                    //       }
                    //     })
                    //     .catch(() => {
                    //       this.$message({
                    //         type: 'error',
                    //         message: '진행률 확인을 실패하였습니다.',
                    //       });
                    //     });
                    // }, 1000);
                  } else {
                    this.$message(MsgUtil.getResultMsgData(action, target, false));
                  }
                }).catch((e) => {
                  this.$message(MsgUtil.getResultMsgData(action, target, false));
                  throw new Error(e);
                });
              }
            } else {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/NetdeviceSlidingButtonGroup.vue